<template>
  <div>
    <!-- <SkipNavigation @open-accessibility-toolbar="openAccessibilityMenu" v-if="isPortalRoute || isExternalUser" /> -->
    <!-- <template v-if="isPortalRoute || isExternalUser">
      <div id="reading-guide"></div>
      <AccessibilityToolbar ref="accessibilityToolbar"/>
    </template> -->
    <router-view/>
  </div>
</template>
<script>
import { core } from './config/pluginInit'
import { startSessionHeartbeat } from './Utils/sessionHeartbeat'
// import AccessibilityToolbar from '@/layouts/Components/AccessibilityToolbar.vue'
// import SkipNavigation from '@/layouts/Components/SkipNavigation.vue'
export default {
  name: 'App',
  components: {
    // AccessibilityToolbar
    // SkipNavigation
  },
  computed: {
    // isPortalRoute () {
    //   return (
    //     this.$route.path.includes('portal/home') ||
    //     this.$route.path.includes('portal/service-details') ||
    //     this.$route.path.includes('portal/services') ||
    //     this.$route.path.includes('portal/all-services') ||
    //     this.$route.path.includes('portal/assistive-device-application') ||
    //     this.$route.path.includes('portal/disability-service-panel') ||
    //     this.$route.path.includes('portal/disability-school/admission-form') ||
    //     this.$route.path.includes('portal/hospital-service/patient-registration') ||
    //     this.$route.path.includes('auth/login')
    //   )
    // },
    // isExternalUser () {
    //   return this.$store.state.Auth.authUser && this.$store.state.Auth.authUser.user_type !== 0
    // }
  },
  created () {
    this.$i18n.locale = this.$store.state.Setting.lang
  },
  mounted () {
    core.mainIndex()
    startSessionHeartbeat()
  },
  methods: {
    // openAccessibilityMenu () {
    //   this.$refs.accessibilityToolbar.togglePanel()
    // }
  }
}
</script>

<style>
/* @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap'); */
/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap'); */
/* Self-hosted Roboto (latin, variable font: one file covers weights 100-900) */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url("./assets/fonts/roboto/roboto-latin.woff2") format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: "Kalpurush" ;
  src: local("Kalpurush"),
   url("./assets/fonts/Kalpurush.ttf") format("truetype");
}
</style>

<style lang="scss">
  @import "assets/scss/style.scss";

  :focus-visible {
  outline: 2px solid #000000!important;
  outline-offset: 2px!important;
  opacity: 1!important;
  z-index: 1000!important;
}
</style>
